export const checkInput = (inputValue) => {
    // for (var i = 0; i < inputValue.length; i++) {
    if (inputValue === '' || inputValue === undefined || inputValue == null) {
        return false
    } else {
        return true
    }
    // }
}

export const checkPhone = (phone) => {
    const reg = /^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/
    return reg.test(phone)
}


export const checkEmail = (email) => {
    const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    return reg.test(email)
}
